import React from "react";

export const SuccessIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="102" height="102" viewBox="0 0 102 102" fill="none" className={className}>
    <circle opacity="0.15" cx="51" cy="51" r="51" fill="#00D372">
      <animate
        attributeName="opacity"
        values="0.2;0.1;0.2"
        dur="2s"
        repeatCount="indefinite"
      />
    </circle>
    <circle cx="51" cy="51" r="29" fill="#1E894D">
      <animate
        attributeName="opacity"
        values="0.9;0.5;0.9"
        dur="2s"
        repeatCount="indefinite"
      />
    </circle>
    <mask id="mask0_1162_17462" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="29" y="28" width="45" height="45">
      <rect x="29.4639" y="28.464" width="44.536" height="44.536" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1162_17462)">
      <path d="M48.0206 58.8971L40.5979 51.4744L43.1958 48.8765L48.0206 53.7012L60.268 41.4538L62.8659 44.0517L48.0206 58.8971Z" fill="white" />
    </g>
  </svg>
);
